<template>
    
    <b-row>
        <b-col md="4" cols="12">
            <info-card
            label="سنة بداية المجلس"
            :value="data.board_year"
            />
        </b-col>
        <b-col md="4" cols="12">
            <info-card
            label="سنة نهاية المجلس"
            :value="data.board_end_year"
            />
        </b-col>
        <b-col md="12" cols="12">
            <div>
                <h5 class="mx-1 mt-2">
                    معلومات الأعضاء
                </h5>
                <hr />
            </div>
            <div>
                <b-tabs content-class="mt-3">
                    <b-tab v-for="(member , i) in data.directors" :key="i" :title="`العضو ${ getArrangement(i+1) }`">
                        <b-row>
                            <b-col md="4" cols="12">
                                <info-card
                                    label="الاسم الكامل"
                                    :value="member.name"
                                />
                            </b-col>
                            <b-col md="4" cols="12">
                                <info-card
                                    label="المؤهل العلمي"
                                    :value="member.qualification_id ? member.qualification_id.title : ''"
                                />
                            </b-col>
                            <b-col md="4" cols="12">
                                <info-card
                                    label="الصفة"
                                    :value="member.job_title_id ? member.job_title_id.name : ''"
                                />
                            </b-col>
                            <b-col md="4" cols="12">
                                <info-card
                                    label="رقم الموبايل"
                                    :value="member.phone_number"
                                />
                            </b-col>
                            <b-col md="4" cols="12">
                                <info-card
                                    label="تاريخ الميلاد"
                                    :value="member.dob"
                                />
                            </b-col>
                            <b-col md="4" cols="12">
                                <info-card
                                    label="الرقم الوطني"
                                    :value="member.ID_number"
                                />
                            </b-col>
                            <b-col cols="4">
                                <div class="info-card px-2 py-1 my-1">
                                <div class="d-flex align-items-center justify-content-between">
                                    <div>
                                    نشرة الإستعلام
                                    </div>
                                    <div>
                                    <b-button
                                    
                                        variant="flat-info"
                                        v-b-toggle.doc-view
                                        class="btn-icon mx-25"
                                        v-b-tooltip.hover.v-info.bottom
                                        title="عرض المستند المرفوع"
                                        :to="{ name: 'file-view', query: { ep:member.inquiry_bulletin_file } }"
                                    >
                                        <feather-icon icon="EyeIcon"
                                    /></b-button>
                                    </div>
                                </div>
                                <div>
                                    <hr />
                                </div>
                                </div>
                            </b-col> 
                        </b-row>
                    </b-tab>
                </b-tabs>
            </div>
        </b-col>  
    </b-row>
  </template>
  
  <script>
  import { BCard , BImg , BCol , BRow , VBToggle , VBTooltip , BButton , BTab  , BTabs} from "bootstrap-vue";
  import InfoCard from "@/components/InfoCard.vue";
  import { arrangement } from "@/utils/utils";
  export default {
    components: {
        BCard, BImg , BCol , InfoCard , BRow , BButton , BTab , BTabs
    },
    props: {
        data: Object
    },
    
    directives: {
        "b-toggle": VBToggle,
        "b-tooltip": VBTooltip,
    },
    methods:{
        getArrangement(num){
            return arrangement(num)
        }
    }
  };


  </script>